export default __webpack_public_path__ + "static/media/swimming.bc12b705.svg";